export { default as default } from './Cercador';
